function isBrowser() {
  return typeof window !== 'undefined' && typeof document !== 'undefined'
}

function ensureGoogleAnalytics(measurementId) {
  if (!isBrowser() || !measurementId) return false

  window.dataLayer = window.dataLayer || []
  window.gtag = window.gtag || function gtag() {
    window.dataLayer.push(arguments)
  }

  if (!document.querySelector(`script[data-ga-measurement-id="${measurementId}"]`)) {
    const script = document.createElement('script')
    script.async = true
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`
    script.dataset.gaMeasurementId = measurementId
    document.head.appendChild(script)
  }

  if (!window.__gaInitializedIds) {
    window.__gaInitializedIds = new Set()
  }

  if (!window.__gaInitializedIds.has(measurementId)) {
    window.gtag('js', new Date())
    window.gtag('config', measurementId, { send_page_view: false })
    window.__gaInitializedIds.add(measurementId)
  }

  return typeof window.gtag === 'function'
}

export function createGoogleAnalyticsHandler({ measurementId }) {
  return {
    name: 'google-analytics',
    initialize() {
      ensureGoogleAnalytics(measurementId)
    },
    handle(event) {
      if (!ensureGoogleAnalytics(measurementId)) return
      window.gtag('event', event.name, event.properties)
    },
  }
}
